import { UntypedFormControl } from '@angular/forms';
import { ViewStudentsViewItem } from 'edu-application/dist/students/view-students/view-students.viewmodel';
import {
  Component,
  ElementRef,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Observable, map, startWith } from 'rxjs';

@Component({
  selector: 'student-selector',
  templateUrl: './student-selector.component.html',
  styleUrls: ['./student-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class StudentSelectorComponent {
  @ViewChild('studentInputMultiple')
  studentInputMultiple!: ElementRef<HTMLInputElement>;
  @ViewChild('studentInputSingle')
  studentInputSingle!: ElementRef<HTMLInputElement>;
  @Input('control') studentControl: UntypedFormControl;
  @Input() multiple?: boolean = false; // Configure multiple selection via input
  @Input() students: ViewStudentsViewItem[] = []; // Accept students as input
  @Output() selectionChange = new EventEmitter<string[]>();
  selectedStudents: string[] = [];

  filteredStudents: Observable<ViewStudentsViewItem[]>;
  constructor() {}

  ngOnInit(): void {
    this.filteredStudents = this.studentControl.valueChanges.pipe(
      startWith(''),
      map((value: string | null) => {
        const filterValue = (value || '').toLowerCase();
        return this.students.filter((student) => {
          const isNotSelected = this.multiple
            ? !this.selectedStudents.some(
                (selected) => selected === student.userName,
              )
            : true;

          return (
            isNotSelected &&
            (student.fullName.toLowerCase().includes(filterValue) ||
              student.userName.toLowerCase().includes(filterValue))
          );
        });
      }),
    );
  }

  // Replace the entire studentSelected method with:
  studentSelected(event: MatAutocompleteSelectedEvent): void {
    if (this.multiple) {
      const student = event.option.value as string;

      if (!this.selectedStudents.some((s) => s === student)) {
        this.selectedStudents.push(student);
        // Emit the selected usernames to parent component
        this.selectionChange.emit(this.selectedStudents);
      }

      // Clear the input field and reset the form control to empty string
      if (this.studentInputMultiple) {
        this.studentInputMultiple.nativeElement.value = '';
      }
      this.studentControl.setValue(''); // Reset to empty string for filtering
    } else {
      const userName = event.option.value as string;
      const student = this.students.find((s) => s.userName === userName);

      if (student) {
        this.selectedStudents = [student.userName];
        this.studentControl.setValue(student.userName);
        this.selectionChange.emit([student.userName]);
      }
    }
  }

  // Replace the entire removeStudent method with:
  removeStudent(studentToRemove: string): void {
    if (this.multiple) {
      const index = this.selectedStudents.findIndex(
        (s) => s === studentToRemove,
      );
      if (index >= 0) {
        this.selectedStudents.splice(index, 1);
        // Emit updated selection
        this.selectionChange.emit(this.selectedStudents);
        // Keep the input clear for continued searching
        this.studentControl.setValue('');
      }
    }
  }
}
